import { Injectable } from '@angular/core'
import { environment } from './../environments/environment'

@Injectable()
export class EnvironmentService {
    appId: string
    backendUrl: string
    production: boolean
    sentryDsn: string
    wsUrl: string
    userpilotToken: string
    POSTHOG_PROJECT_KEY: string | undefined

    constructor() {
        this.appId = environment.appId
        this.backendUrl = environment.backendUrl || `https://${window.location.host}`
        this.production = environment.production
        this.sentryDsn = environment.SENTRY_DSN
        this.wsUrl = environment.wsUrl || `wss://${window.location.host}`
        this.userpilotToken = environment.USERPILOT_TOKEN
        this.POSTHOG_PROJECT_KEY = environment.POSTHOG_PROJECT_KEY
    }
}
